import React from 'react'
import classNames from 'classnames'

type Props = {
    current?: number
    negative?: boolean
    max: number
    barClass?: string
    backgroundClass?: string
}

const DefaultProgressBar = ({
    current,
    negative,
    max,
    barClass,
    backgroundClass
}: Props) => {
    const val: number = current || 0
    const percent = max > 0 ? (val / max) * 100 : 0

    return (
        <div className={classNames('defaultProgressBar', backgroundClass)}>
            <div
                style={{ width: `${percent}%` }}
                className={classNames('defaultProgressBar__bar', barClass, {
                    negative,
                    zero: percent === 0
                })}
            />
        </div>
    )
}

export default DefaultProgressBar
